import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../../../../shared/shared.module';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-activation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    SharedModule
  ],
  templateUrl: './account-activation-dialog.component.html'
})
export class AccountActivationDialogComponent implements OnInit {
  form: FormGroup;
  mode: string = "";
  codeConfirmed: boolean = false;
  oldEmail: string = "";

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    public dialogRef: MatDialogRef<AccountActivationDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { verificationCode: string, email: string }
  ) {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*/]).{8,}$/)
      ]],
      confirmPassword: ['', Validators.required],
    }, { validators: this.passwordsMatch });
  }

  ngOnInit(): void {
    if (!!this.data.verificationCode) {
      this.mode = "code";
      this.http.get<any>(`${environment.api.AUTH_URL}/activation-info?code=${this.data.verificationCode}`).subscribe({
        next: userInfo => {
          console.log(">> USER INFO :", userInfo);
          
          this.form.patchValue({
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            email: userInfo.email,
          });

          this.oldEmail = userInfo.email
        },
        error: () => {
          alert("Code invalide ou expiré.");
          this.dialogRef.close();
        }
      });
    } else {
      this.mode = "email";
      const email = this.data.email;
      const payload = {
        oldEmail: email,
        action: "CONFIRM_EMAIL"
      };
      this.http.patch(`${environment.api.AUTH_URL}/account/activate`, payload , { responseType: 'text' }).subscribe({
        next: () => {
          // Email confirmation success is now handled by the template
          // The dialog will show the success message
        },
        error: err => {
          console.error(err);
        }
      });
    }
  }

  passwordsMatch(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return pass === confirm ? null : { notMatching: true };
  }

  get passwordFormField(): string {
    return this.form.get('password')?.value || '';
  }

  redirectToLogin() {
    this.dialogRef.close();
    this.router.navigate(['/login']);
  }

  submit() {
    if (this.form.valid) {
      const payload = {
        ...this.form.value,
        code: this.data.verificationCode,
        action: "CONFIRM_DATA",
        oldEmail: this.oldEmail
      };
      this.http.patch(`${environment.api.AUTH_URL}/account/activate`, payload , { responseType: 'text' }).subscribe({
        next: () => {
          // Show success message instead of alert
          this.codeConfirmed = true;
        },
        error: err => {
          console.error(err);
        }
      });
    }
  }
}
